import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { homepageData } from "@/mocks/homeData";

export default function HeroSection() {
  const navigate = useNavigate();
  const { hero } = homepageData;

  const scrollRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    let frame = 0;
    const animate = () => {
      frame++;
      if (scrollRef.current && frame % 2 === 0) {
        scrollRef.current.style.transform = `translateY(${Math.sin(frame * 0.05) * 6}px)`;
      }
      requestAnimationFrame(animate);
    };
    const id = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(id);
  }, []);

  return (
    <section
      className="relative overflow-hidden flex items-center justify-center"
      style={{ minHeight: "100svh" }}
    >
      <video
        className="absolute inset-0 w-full h-full object-cover"
        src="https://public.readdy.ai/ai/video_res/019fb0de-9132-7dd0-89fa-1adc4e20961b.mp4"
        autoPlay
        loop
        muted
        playsInline
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/40" />
      <div className="relative z-10 text-left px-4 w-full max-w-4xl mx-auto">
        <h1
          className="font-heading text-lg md:text-xl font-semibold text-background-50 tracking-widest mb-5"
        >
          {hero.brandName}
        </h1>
        <h2
          className="font-heading text-3xl md:text-5xl font-bold leading-snug max-w-3xl tracking-wide text-background-50 whitespace-pre-line"
        >
          {hero.mainTitle}
        </h2>
        <p
          className="mt-4 md:mt-6 text-base md:text-lg text-background-50 max-w-2xl leading-relaxed font-body"
        >
          {hero.subtitle}
        </p>
        <p
          className="mt-3 md:mt-4 text-sm md:text-base text-background-50 font-heading tracking-wider"
        >
          {hero.tagline}
        </p>
        <div className="mt-6 md:mt-8 flex flex-col sm:flex-row items-start gap-3">
          {hero.ctaButtons.map((btn) => (
            <button
              key={btn.label}
              onClick={() => {
                window.scrollTo(0, 0);
                navigate(btn.href);
              }}
              className="px-6 py-3 text-sm font-medium rounded-md transition-all duration-200 cursor-pointer whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600"
            >
              {btn.label}
            </button>
          ))}
        </div>
      </div>
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10" ref={scrollRef}>
        <i className="ri-arrow-down-line text-2xl text-foreground-300"></i>
      </div>
    </section>
  );
}